<template>
    <div style="height:100%;width:100%;display:flex;flex-direction:row;">
        <Portlet class="main-portlet" :fullHeight="true" :headSeparator="true">
            <template slot="Title">
                <router-view name="subPageHeader"></router-view>
            </template>
            <template slot="Options">
                <router-view name="pageActions"></router-view>
            </template>
            <template slot="PortletNav">
                <router-view name="pageSubMenu"></router-view>
            </template>
            <template slot="Content">
                <transition name="fade" mode="out-in">
                    <router-view></router-view>
                </transition>
                <!-- Modal Edition -->
                <DayTemplateEditionCard :dayTemplateUid="editedDayTemplateUid" v-if="editedDayTemplateUid"></DayTemplateEditionCard>
                <DayTemplateRemovalCard ref="removeModal" v-if="deletedDayTemplateUid" :dayTemplateUid="deletedDayTemplateUid"></DayTemplateRemovalCard>
            </template>
        </Portlet>
        <router-view name="rightPanel"></router-view>
    </div>
</template>
<script>
    import store from '@/store'
    import Portlet from'@/components/common/Portlet.vue'
    import Translations from '@/store/translations';
    import EventBus from '@/eventbus';
    import Constants from '@/store/constants';
    import DayTemplateEditionCard from './DayTemplateEditionCard.vue';
    import DayTemplateRemovalCard from './DayTemplateRemovalCard.vue';
    import { HTTP } from "@/utils/http";
    import Apis from '@/apis/index'
    import router from '@/router';

    export default {
        name: 'MasterDaytemplates',
        store,
        created() {
            EventBus.$on("onDayTemplateEdition", this.editDayTemplate);
            EventBus.$on("onDayTemplateEditionEnded", this.onStopEditDayTemplate);
            //-------------------------------------------------------------------------
            EventBus.$on("onDayTemplateDelete", this.onDeleteDayTemplate);
            EventBus.$on('onDayTemplateDeleted', this.onDayTemplateDeleted);
            EventBus.$on("onDayTemplateDeleteEnded", this.onStopDeleteDayTemplate);
            //-------------------------------------------------------------------------
            EventBus.$on('onDayTemplateDuplicate', this.onDayTemplateDuplicate);
        },
        beforeDestroy() {
            EventBus.$off("onDayTemplateEdition", this.editDayTemplate);
            EventBus.$off("onDayTemplateEditionEnded", this.onStopEditDayTemplate);
            //-------------------------------------------------------------------------
            EventBus.$off("onDayTemplateDelete", this.onDeleteDayTemplate);
            EventBus.$off('onDayTemplateDeleted', this.onDayTemplateDeleted);
            EventBus.$off("onDayTemplateDeleteEnded", this.onStopDeleteDayTemplate);
            //-------------------------------------------------------------------------
            EventBus.$off('onDayTemplateDuplicate', this.onDayTemplateDuplicate);
        },
        watch: {
            "$route.params.dayTemplateUid": function (to, from) {
                //store.dispatch("loadStationDayTemplates", this.$route.params.stationUid);
            }
        },
        computed: {
            Constants: () => Constants,
            Translations: () => Translations,
        },
        components: {
            Portlet, DayTemplateEditionCard, DayTemplateRemovalCard
        },
        data() {
            return {
                editedDayTemplateUid: null,
                deletedDayTemplateUid: null,
            }
        },
        methods: {
            editDayTemplate: function (dtUid) {
                console.log("Master DayTemplate : editDayTemplate")
                this.editedDayTemplateUid = dtUid;
            },
            onStopEditDayTemplate: function () {
                console.log("Master DayTemplate : stopEditDayTemplate")
                this.editedDayTemplateUid = null;
                //store.dispatch("loadDayTemplate", this.$route.params);
                //store.dispatch("loadStationDayTemplates", this.$route.params.stationUid);
            },
            onDeleteDayTemplate: function (dtUid) {
                if (!dtUid) {
                    console.log("Master DayTemplate : onDeleteDayTemplate - dtUid not defined", dtUid)
                    return;
                }
                console.log("Master DayTemplate : onDeleteDayTemplate", dtUid)
                this.deletedDayTemplateUid = dtUid;
                if (this.$refs["removeModal"]) this.$refs["removeModal"].show();
            },
            async onDayTemplateDeleted(dtUid) {
                console.log("Master DayTemplate : onDayTemplateDeleted")
                this.deletedDayTemplateUid = null;
                await store.dispatch("loadStationDayTemplates", this.$route.params.stationUid);

                // redirect to home day template if if we are within to deleted day template
                if(this.$route.params.dayTemplateUid === dtUid){
                    await this.$router.push({
                        name: 'DayTemplatesHome',
                        params: {
                            stationUid:this.$route.params.stationUid
                        }
                    });
                }
            },
            stopDeleteDayTemplate: function () {
                console.log("Master DayTemplate : stopDeleteDayTemplate")
                this.deletedDayTemplateUid = null;
                //store.dispatch("loadStationDayTemplates", this.$route.params.stationUid);
            },
            //-----------------------------------------------------------------------------------------

            async onDayTemplateDuplicate(dayTemplateUid) {
                try {
                    const response = await HTTP.post(Apis.daytemplates.duplicate, {
                        stationUid: this.$route.params.stationUid,
                        boxUid: dayTemplateUid
                    });

                    console.log('response duplicate Day Template :', response);
                    await store.dispatch('loadStationDayTemplates', this.$route.params.stationUid);
                    if (response.data.dataItem.uid) {
                        await router.push({
                            name: 'DayTemplateDetails', params: {
                                stationUid:this.$route.params.stationUid,
                                dayTemplateUid: response.data.dataItem.uid
                            }
                        });
                    }
                    // TODO : redirect to day template clock
                }
                catch (e) {
                    console.log('error duplicate day Template :', e);
                }
            },
        }
    };

</script>

<style scoped>
</style>
